"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ReplaceMeter = class ReplaceMeter extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    labelAlign;
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('ReplaceMeter');
    }
    responseData;
    workflowStepsInfo;
    units;
    async $$load_units() {
        return this.$fn.fetch('get_meter_type_units');
    }
    selectedOldMeter;
    old_reading_image;
    new_reading_image;
    ux;
    b_4963030162390099_dataSource;
    b_4246589045129675_dataSource;
    dataMembers = ['formId', 'labelAlign', 'item', 'responseData', 'workflowStepsInfo', 'units', 'selectedOldMeter', 'old_reading_image', 'new_reading_image', 'ux', 'b_4963030162390099_dataSource', 'b_4246589045129675_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                labelAlign: "right",
                item: null,
                responseData: null,
                workflowStepsInfo: {
                    steps: ["rögzíti a leszerelt mérőóra állását",
                        "inaktiválja a leszerelt órát",
                        "inaktiválja a kapcsolódó bérleménynél beállított mért szolgáltatást",
                        "létrehoz egy új mérőórát a megadott sorozatszámmal",
                        "rögzíti az induló mérőállást",
                        "a kapcsolódó bérleménynél a leszerelt mérőóra helyett beállít egy mért szolgáltatást az új mérőórával",
                    ],
                },
                units: null,
                selectedOldMeter: null,
                old_reading_image: null,
                new_reading_image: null,
                ux: null,
                b_4963030162390099_dataSource: {
                    name: "suggest_meter",
                    parameters: {
                        exclude_types: ["pulse",
                        ],
                    },
                },
                b_4246589045129675_dataSource: {
                    name: "suggest_meter",
                    parameters: {
                        exclude_types: ["pulse",
                        ],
                    },
                },
            },
        };
    }
    get isReadOnly() {
        if (this.loaded) {
            return !!(this.responseData || (this.actions.submit && this.actions.submit.isRunning));
        }
        return null;
    }
    get oldMeterReadingUnitOptions() {
        if (this.loaded) {
            return this.selectedOldMeter ? this.units[this.selectedOldMeter.meter_type] : [];
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("ReplaceMeterModal.Title", "Replace Meter"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3684_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_setData_3690_getActionArgs($event) {
        return {
            path: "responseData",
            value: $event.data.response.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_1040167445267876_request_3688_getActionArgs($event) {
        return {
            operation: "create_meter_operation",
            data: this.item,
            parameters: {
                op: "replacement",
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_4963030162390099_setData_3692_getActionArgs($event) {
        return {
            path: "item.old_meter.unit",
            value: $event.data.option.unit,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4963030162390099_setData_3694_getActionArgs($event) {
        return {
            path: "selectedOldMeter",
            value: $event.data.option,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_4963030162390099_optionSelected(event, scope) {
        return await this.actions.evh_4963030162390099_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_3855552110905499_setData_3696_getActionArgs($event) {
        return {
            path: "item.old_meter.image",
            value: this.$fn.imageData($event.value),
            resolve: true,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_3855552110905499_changed(event, scope) {
        return await this.actions.evh_3855552110905499_changed.executeFromDOM(this, event, scope);
    }
    async act_4246589045129675_setData_3698_getActionArgs($event) {
        return {
            path: "item.new_meter.serial",
            value: $event.data.option.serial_number,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4246589045129675_setData_3698_getWhen($event) {
        return $event.data.option;
    }
    async act_4246589045129675_setData_3700_getActionArgs($event) {
        return {
            path: "item.new_meter.id",
            value: $event.data.option.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4246589045129675_setData_3700_getWhen($event) {
        return $event.data.option;
    }
    async act_4246589045129675_setData_3702_getActionArgs($event) {
        return {
            path: "item.new_meter.unit",
            value: $event.data.option.unit,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4246589045129675_setData_3702_getWhen($event) {
        return $event.data.option;
    }
    async evh_4246589045129675_optionSelected(event, scope) {
        return await this.actions.evh_4246589045129675_optionSelected.executeFromDOM(this, event, scope);
    }
    async evh_353388685162594_clickPreventStop(event, scope) {
        return await this.actions.evh_353388685162594_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3684 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3684_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3683 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3684,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3683],
        });
        const act_2248226175642056_closeComponent_3686 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3685 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3686,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3685],
        });
        const act_1040167445267876_setData_3690 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_3690_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3689 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_3690,
            event: "success",
            displayName: "setData",
        });
        const act_1040167445267876_request_3688 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_3688_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_3689],
        });
        const evh_1040167445267876_submit_3687 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_3688,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3687],
        });
        const act_4963030162390099_setData_3692 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4963030162390099_setData_3692_getActionArgs,
            events: [],
        });
        const evh_4963030162390099_optionSelected_3691 = new core_1.actions.EventHandlerImpl({
            action: act_4963030162390099_setData_3692,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_4963030162390099_setData_3694 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4963030162390099_setData_3694_getActionArgs,
            events: [],
        });
        const evh_4963030162390099_optionSelected_3693 = new core_1.actions.EventHandlerImpl({
            action: act_4963030162390099_setData_3694,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_4963030162390099_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4963030162390099_optionSelected_3691, evh_4963030162390099_optionSelected_3693],
        });
        const act_3855552110905499_setData_3696 = new core_1.actions.SetDataAction({
            actionArgs: this.act_3855552110905499_setData_3696_getActionArgs,
            events: [],
        });
        const evh_3855552110905499_changed_3695 = new core_1.actions.EventHandlerImpl({
            action: act_3855552110905499_setData_3696,
            event: "changed",
            displayName: "setData",
        });
        const evh_3855552110905499_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3855552110905499_changed_3695],
        });
        const act_4246589045129675_setData_3698 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4246589045129675_setData_3698_getActionArgs,
            when: this.act_4246589045129675_setData_3698_getWhen,
            events: [],
        });
        const evh_4246589045129675_optionSelected_3697 = new core_1.actions.EventHandlerImpl({
            action: act_4246589045129675_setData_3698,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_4246589045129675_setData_3700 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4246589045129675_setData_3700_getActionArgs,
            when: this.act_4246589045129675_setData_3700_getWhen,
            events: [],
        });
        const evh_4246589045129675_optionSelected_3699 = new core_1.actions.EventHandlerImpl({
            action: act_4246589045129675_setData_3700,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_4246589045129675_setData_3702 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4246589045129675_setData_3702_getActionArgs,
            when: this.act_4246589045129675_setData_3702_getWhen,
            events: [],
        });
        const evh_4246589045129675_optionSelected_3701 = new core_1.actions.EventHandlerImpl({
            action: act_4246589045129675_setData_3702,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_4246589045129675_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4246589045129675_optionSelected_3697, evh_4246589045129675_optionSelected_3699, evh_4246589045129675_optionSelected_3701],
        });
        const act_353388685162594_closeComponent_3704 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_353388685162594_clickPreventStop_3703 = new core_1.actions.EventHandlerImpl({
            action: act_353388685162594_closeComponent_3704,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_353388685162594_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_353388685162594_clickPreventStop_3703],
        });
        const act_1548630417156826_closeComponent_3706 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_3705 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_3706,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_3705],
        });
        return {
            act_7315092382398562_closeModal_3684,
            evh_7315092382398562_close_3683,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3686,
            evh_2248226175642056_close_3685,
            evh_2248226175642056_close,
            act_1040167445267876_setData_3690,
            evh_1040167445267876_success_3689,
            act_1040167445267876_request_3688,
            evh_1040167445267876_submit_3687,
            evh_1040167445267876_submit,
            act_4963030162390099_setData_3692,
            evh_4963030162390099_optionSelected_3691,
            act_4963030162390099_setData_3694,
            evh_4963030162390099_optionSelected_3693,
            evh_4963030162390099_optionSelected,
            act_3855552110905499_setData_3696,
            evh_3855552110905499_changed_3695,
            evh_3855552110905499_changed,
            act_4246589045129675_setData_3698,
            evh_4246589045129675_optionSelected_3697,
            act_4246589045129675_setData_3700,
            evh_4246589045129675_optionSelected_3699,
            act_4246589045129675_setData_3702,
            evh_4246589045129675_optionSelected_3701,
            evh_4246589045129675_optionSelected,
            act_353388685162594_closeComponent_3704,
            evh_353388685162594_clickPreventStop_3703,
            evh_353388685162594_clickPreventStop,
            act_1548630417156826_closeComponent_3706,
            evh_1548630417156826_clickPreventStop_3705,
            evh_1548630417156826_clickPreventStop,
            submit: act_1040167445267876_request_3688,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], ReplaceMeter.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ReplaceMeter.prototype, "onSize", null);
ReplaceMeter = __decorate([
    (0, vue_property_decorator_1.Component)()
], ReplaceMeter);
exports.default = ReplaceMeter;
vue_property_decorator_1.Vue.component("ReplaceMeter", ReplaceMeter);
